export default __webpack_public_path__ + "static/media/VAAGAI.24074992.jpg";